<template>
    <div class="contact-popup__success">
        <h2 id="contact-popup-title" class="contact-popup__title">
            Bedankt voor je aanvraag!
        </h2>
        <p class="contact-popup__success-text">
            We hebben je aanvraag in goede orde ontvangen en nemen zo snel
            mogelijk contact met je op.
        </p>
        <button type="button" class="button button--full" @click="$emit('close')">
            Sluiten
        </button>
    </div>
</template>

<script>
export default {
    name: "SuccessMessage",
    emits: ["close"],
};
</script>
